import gql from 'graphql-tag';
import { TypedDocumentNode } from 'apollo-angular';
import { DtModelFormatEnum } from '@app/pages/digital-twin/interfaces/dt-model-format.enum';

export type DigitalTwinModelResponseType = {
	format: DtModelFormatEnum;
	isFavorite: boolean;
	modelId: string;
	id: number;
	isFragmentConverted: boolean;
};

export const digitalTwinDetailsQuery: TypedDocumentNode<
	{
		buildings: {
			digitalTwin: {
				models: DigitalTwinModelResponseType[];
			};
		}[];
	},
	{ buildingsId: string[] }
> = gql`
	query digitalTwinDetailsQuery($buildingsId: [UUID]) {
		buildings(buildingsId: $buildingsId) {
			digitalTwin {
				models {
					format
					isFavorite
					modelId
					id
					isFragmentConverted
				}
			}
		}
	}
`;
